import React from 'react';
import { cn } from '../utils';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
    hoverable?: boolean;
    glass?: boolean;
}

export const Card: React.FC<CardProps> = ({
    children,
    className,
    hoverable = true,
    glass = true,
    ...props
}) => {
    return (
        <div
            className={cn(
                "rounded-lg border border-gray-100 overflow-hidden bg-white transition-all duration-300",
                glass && "bg-white/70 backdrop-blur-md border-white/20",
                hoverable && "hover:shadow-premium-hover hover:-translate-y-1",
                !hoverable && "shadow-premium",
                className
            )}
            {...props}
        >
            {children}
        </div>
    );
};

export const CardHeader: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, className, ...props }) => (
    <div className={cn("p-6", className)} {...props}>
        {children}
    </div>
);

export const CardContent: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, className, ...props }) => (
    <div className={cn("p-6 pt-0", className)} {...props}>
        {children}
    </div>
);

export const CardFooter: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, className, ...props }) => (
    <div className={cn("p-6 border-t border-gray-50 flex items-center", className)} {...props}>
        {children}
    </div>
);
